module.exports = __webpack_public_path__ + "img/employees.7549f354.png";